<template>
	<div class="page-dashboard relative">
		<div class="container-fluid">
			<h2 class="text-primary mb-4">{{ $t(title) }}</h2>
			<!-- Table Menu -->
			<div class="table-menu flex-center">
				<div>
					<button
						class="btn btn-submit btn-default"
						@click="addItem">
						{{ $t('Create Output') }}
					</button>
					<button
						v-if="filteredDisplayRundown.length > 1"
						class="btn btn-submit btn-primary ml-3"
						@click="goToMutilview" v-click-outside="hideContextRundown" @contextmenu.prevent @contextmenu="toggleContextRundown()">
						{{ $t('Multiview') }}
					</button>
				</div>
				<!-- counting -->
				<div class="mr-3 ml-a">
					<md-menu md-align-trigger md :md-offset-x=10>
						<button class="btn-icon btn p-0 m-0 w-100 btn-click" md-menu-trigger>
								{{ page * limit - (limit - 1) }} - {{ items.length > 0 ? page * limit : items.length }} of {{ totalItems }}
						</button>
						<!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
						<md-menu-content>
							<md-menu-item @click="changeLimit(10)"><span class="text-center minw-50">10</span></md-menu-item>
							<md-menu-item @click="changeLimit(25)"><span class="text-center minw-50">25</span></md-menu-item>
							<md-menu-item @click="changeLimit(50)"><span class="text-center minw-50">50</span></md-menu-item>
							<md-menu-item @click="changeLimit(100)"><span class="text-center minw-50">100</span></md-menu-item>
							<md-menu-item @click="changeLimit(200)"><span class="text-center minw-50">200</span></md-menu-item>
						</md-menu-content>
					</md-menu>
				</div>
				<div>
					<input
						type="text"
						class="form-control"
						:placeholder="$t('Search')"
						@input="onKeywordChange"
						v-model="keyword"
					/>
				</div>
			</div>
			<!-- Main Table -->
			<table class="table table-striped mb-4">
				<thead>
					<tr>
						<th class="text-center" width="10%">{{ $t('Status') }}</th>
						<th>{{ $t('Output Name') }}</th>
						<th width="20%">{{ $t('Output Layers') }}</th>
						<th>{{ $t('Size') }}</th>
						<th width="10%">{{ $t('Delay (ms)') }}</th>
						<th>{{ $t('Rundown') }}</th>
						<!-- <th class="text-center">{{ $t('Total Access') }}</th> -->
						<th width="20%">{{ $t('') }}</th>
					</tr>
				</thead>
				<div class="p-5 text-center absolute" v-if="isFetching">
					<div class="is-loading large"></div>
				</div>
				<tbody>
					<tr
						v-for="item in items"
						:key="item.id">
						<td @mouseover="itemHover(item)" @mouseleave="itemLeave(item)" class="text-center">
							<div
								class="status-dot m-auto"
								:class="{ 'active': item.is_active }"
								v-tooltip="item.is_active ? 'Active' : 'Inactive'">
							</div>
						</td>
						<td @mouseover="itemHover(item)" @mouseleave="itemLeave(item)">{{ item.name }}</td>
						<td @mouseover="itemHover(item)" @mouseleave="itemLeave(item)">
							<span v-for="(itemIndex, index) in JSON.parse(item.layer_index)" :key="index">
								<md-chip class="mr-2 chip-item" :class="{'chip-item-hover': hover && hoverItem === item.id}" v-if="itemIndex === '0'">
									All
								</md-chip>
								<md-chip class="mr-2 chip-item" :class="{'chip-item-hover': hover && hoverItem === item.id}" v-if="itemIndex !== '0'">
									{{ itemIndex }}
								</md-chip>
							</span>
						</td>
						<td @mouseover="itemHover(item)" @mouseleave="itemLeave(item)">{{ item.displaySize ? `${item.displaySize.name} (${item.displaySize.width} - ${item.displaySize.height})`: '-' }}</td>
						<td @mouseover="itemHover(item)" @mouseleave="itemLeave(item)">{{ item && item.delay ? item.delay : '-'  }}</td>
						<td @mouseover="itemHover(item)" @mouseleave="itemLeave(item)" @click="goToRundown(item.rundown)">
							<md-chip v-if="item.rundown && item.rundown.name" class="mr-2 chip-item pointer" :class="{'chip-item-hover': hover && hoverItem === item.id}">
								{{ item.rundown.name }}
							</md-chip>
							<div class="ml-3" v-else>
								-
							</div>
						</td>
						<!-- <td @mouseover="itemHover(item)" @mouseleave="itemLeave(item)"><div class="text-center">{{ item.__meta__ && item.__meta__.total_access ? item.__meta__.total_access : 0  }}</div></td> -->
						<!-- Actions -->
						<td class="btn-action-table text-right" @mouseover="itemHover(item)" @mouseleave="itemLeave(item)">
							<!-- Duplicate -->
							<button v-if="hover && hoverItem === item.id"
								class="btn btn-default btn-icon mr-3"
								:class="{ 'is-loading': selected && selected.id === item.id && isDuplicating }"
								@click="duplicateItem(item)"
								v-tooltip="'Duplicate'">
								<i class="material-icons md-18">content_copy</i>
							</button>
							<!-- View -->
							<button v-if="hover && hoverItem === item.id"
								class="btn btn-default btn-icon mr-3"
								@click="view(item)"
								v-tooltip="'View in browser'">
								<!-- <i class="material-icons md-18">earth</i> -->
								<i class="material-icons md-18">public</i>
							</button>
							<!-- Edit -->
							<button v-if="hover && hoverItem === item.id"
								class="btn btn-default btn-icon mr-3"
								@click="editItem(item)"
								v-tooltip="'Edit'">
								<i class="material-icons md-18">edit</i>
							</button>
							<!-- Remove -->
							<button v-if="hover && hoverItem === item.id && item.user_id === user.id"
								class="btn btn-default btn-icon mr-3"
								@click="confirmClearItem(item)"
								v-tooltip="'Clear Output Access'">
								<i class="material-icons md-18">refresh</i>
							</button>
							<!-- Remove -->
							<button v-if="hover && hoverItem === item.id && item.user_id === user.id"
								class="btn btn-danger btn-icon"
								@click="confirmRemoveItem(item)"
								v-tooltip="'Remove'">
								<i class="material-icons md-18">delete</i>
							</button>
						</td>
					</tr>
				</tbody>
				<div class="text-center absolute disabled mt-4" v-if="items.length === 0 && !isFetching">{{$t('No Display available')}}</div>
			</table>
			<!-- Table Pagination -->
			<pagination
				v-if="!isFetching"
				:total-pages="totalPages"
				:current-page="page"
				:last-page="lastPage"
				@select="onPageSelected">
			</pagination>
		</div>
		<!-- Modals -->
		<div class="modals">
			<!-- Form -->
			<display-form
				:sizes="sizes"
				:data="selected"
				@saved="insertItem"
				@close="isFormVisible = false"
				v-if="isFormVisible"
			/>

			<!-- Delete Confirmation -->
			<modal
				size="small"
				@close="isConfirmRemoveVisible = false"
				v-if="isConfirmRemoveVisible && selected">
				<template slot="header">
					{{ $t('Confirm Delete') }}
				</template>
				<template slot="body">
					{{ $t('Delete Output') }} {{ selected.name }}?
				</template>
				<template slot="footer">
					<div class="w-100 flex-center">
						<button
							class="btn btn-primary"
							:class="{ 'is-loading': isRemoving }"
							@click="removeItem(selected)">
							{{ $t('Yes, Delete It') }}
						</button>
						<button
							class="btn btn-default"
							@click="isConfirmRemoveVisible = false">
							{{ $t('Cancel') }}
						</button>
					</div>
				</template>
			</modal>
			<!-- Clear Confirmation -->
			<modal
				size="small"
				@close="isConfirmClearVisible = false"
				v-if="isConfirmClearVisible && selected">
				<template slot="header">
					{{ $t('Confirm Clear Output Access') }}
				</template>
				<template slot="body">
					{{ $t('Clear Output') }} {{ selected.name }}?
				</template>
				<template slot="footer">
					<div class="w-100 flex-center">
						<button
							class="btn btn-primary"
							:class="{ 'is-loading': isClear }"
							@click="clearItem(selected)">
							{{ $t('Yes, Clear It') }}
						</button>
						<button
							class="btn btn-default"
							@click="isConfirmClearVisible = false">
							{{ $t('Cancel') }}
						</button>
					</div>
				</template>
			</modal>
		</div>
	</div>
</template>

<script>
import ClickOutside from 'vue-click-outside';
import { mapGetters, mapActions } from 'vuex';
import Modal from '@/components/Modal.vue';
import DisplayForm from '@/components/DisplayForm.vue';
import Pagination from '@/components/Pagination.vue';
import { getAxiosErrorMessage, delay, copyToClipboard } from '@/lib/helper';
import displaysApi from '@/api/displays';
import displaySizesApi from '@/api/display-sizes';

export default {
	name: 'Displays',
	components: {
		Modal,
		DisplayForm,
		Pagination,
	},
	data() {
		return {
			page: 1,
			limit: 10,
			orderBy: 'id',
			sortBy: 'asc',
			keyword: '',
			role: 'client',
			isAll: false,
			items: [],
			selected: null,
			// totalPages: 2,
			totalItems: 0,
			lastPage: 1,
			roles: [
				{ key: 'all', label: 'All Roles' },
				{ key: 'client', label: 'Client' },
				{ key: 'super_admin', label: 'Super Admin' },
				{ key: 'collaborator', label: 'Collaborator' },
			],
			filterRole: null,
			isFormVisible: false,
			isConfirmRemoveVisible: false,
			isRemoving: false,
			isConfirmClearVisible: false,
			isClear: false,
			title: 'Outputs',
			isDuplicating: false,
			isFetching: false,
			hover: false,
			hoverItem: null,
			sizes: [],
			isContext: false,
		};
	},
	directives: {
		ClickOutside,
	},
	methods: {
		itemLeave() {
			this.hover = false;
			this.hoverItem = null;
		},
		itemHover(item) {
			this.hover = true;
			this.hoverItem = item.id;
		},
		...mapActions({
		}),
		fetch(reset = false, page) {
			this.isFetching = true;
			if (reset) {
				this.page = 1;
				this.items = [];
			}
			if (page) {
				this.page = page;
			}
			const params = this.fetchParams;
			const callback = (response) => {
				const items = response.data;
				if (items.length < this.limit) {
					this.isAll = true;
				}
				this.items = items;
				this.totalItems = response.total;
				this.lastPage = response.lastPage;
				this.isFetching = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Outputs',
					text: message,
				});
				this.isFetching = false;
			};
			displaysApi.getList(params, callback, errorCallback);
		},
		onKeywordChange() {
			delay(() => {
				this.fetch(true);
			}, 500);
		},
		insertItem(item) {
			const index = this.items.findIndex(({ id }) => id === item.id);
			if (index === -1) {
				this.items.push(item);
			} else {
				this.$set(this.items, index, item);
			}
		},
		addItem() {
			this.selected = null;
			this.isFormVisible = true;
		},
		editItem(item) {
			this.selected = item;
			this.isFormVisible = true;
		},
		confirmRemoveItem(item) {
			this.selected = item;
			this.isConfirmRemoveVisible = true;
		},
		confirmClearItem(item) {
			this.selected = item;
			this.isConfirmClearVisible = true;
		},
		removeItem(item) {
			this.isRemoving = true;
			const callback = (response) => {
				const message = response.message;
				const index = this.items.findIndex(({ id }) => id === item.id);
				if (index !== -1) {
					this.items.splice(index, 1);
				}
				this.isRemoving = false;
				this.isConfirmRemoveVisible = false;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Remove Output',
					text: message,
				});
			};
			const errorCallback = (e) => {
				this.isRemoving = false;
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Remove Output',
					text: message,
				});
			};
			displaysApi.delete(item.id, callback, errorCallback);
		},
		clearItem(item) {
			this.isClear = true;
			const callback = (response) => {
				const message = response.message;
				this.isClear = false;
				this.isConfirmClearVisible = false;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Clear Output',
					text: message,
				});
			};
			const errorCallback = (e) => {
				this.isClear = false;
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Clear Output',
					text: message,
				});
			};
			displaysApi.clearAccess(item.id, callback, errorCallback);
		},
		duplicateItem(item) {
			this.isDuplicating = true;
			const name = `Duplicate of ${item.name}`;
			const description = item.description;
			const params = {
				name,
				description,
				display_size_id: item.display_size_id,
				is_active: item.is_active,
				is_default: item.is_default,
				is_transparent: item.is_transparent,
				is_preload: item.is_preload,
				layer_index: item.layer_index,
				background_color: item.background_color,
			};
			const callback = (response) => {
				const duplicatedItem = response.data;
				this.items.push(duplicatedItem);
				const message = response.message;
				this.isDuplicating = false;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Duplicate Output',
					text: message,
				});
			};
			const errorCallback = (e) => {
				this.isDuplicating = false;
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Duplicate Output',
					text: message,
				});
			};
			displaysApi.create(params, callback, errorCallback);
		},
		onPageSelected(page) {
			this.fetch(true, page);
		},
		view(item) {
			const rundownId = item && item.rundown && item.rundown.id ? item.rundown.id : '';
			const url = `displays/live/${item.slug}/${item.id}?rundown_id=${rundownId}`;
			// this.$router.push(url);
			const route = this.$router.resolve({ path: url });
			// let route = this.$router.resolve('/link/to/page'); // This also works.
			window.open(route.href, '_blank');
			// window.open(url);
			// toggleFullScreen();
		},
		changeLimit(value) {
			this.limit = value;
			this.fetch(true);
		},
		fetchSizes() {
			const params = {
				page: 1,
				limit: 1000,
				order_by: 'name',
				sort_by: 'asc',
			};
			const callback = (response) => {
				const sizes = response.data;
				this.sizes = sizes;
			};
			const errorCallback = () => {};
			displaySizesApi.getList(params, callback, errorCallback);
		},
		goToMutilview() {
			const routeData = this.$router.resolve(`/multiview-displays/${btoa(`?ownmultipviewuserid=${this.user.id}`)}`);
			window.open(routeData.href, '_blank');
		},
		toggleContextRundown() {
			this.isContext = !this.isContext;
			const baseUrl = process.env.VUE_APP_URL;
			const url = `${baseUrl}/multiview-displays/${btoa(`?ownmultipviewuserid=${this.user.id}`)}`;
			copyToClipboard(url);
			const message = this.$t('URL copied to clipboard');
			this.$notify({
				group: 'app',
				type: 'success',
				title: 'Multiple Output Display',
				text: message,
			});
		},
		hideContextRundown() {
			this.isContext = false;
		},
		goToRundown(rundown) {
			if (rundown && rundown.slug) {
				this.$router.push(`/rundowns/editor/${btoa(rundown.slug)}`);
			}
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			isCollaborator: 'isCollaborator',
		}),
		fetchParams() {
			const params = {
				page: this.page,
				limit: this.limit,
				order_by: this.orderBy,
				sort_by: this.sortBy,
			};
			const keyword = this.keyword.trim();
			if (keyword !== '') {
				params.keyword = keyword;
			}
			return params;
		},
		totalPages() {
			const total = Math.ceil(this.totalItems / this.limit);
			return total;
		},
		filteredDisplayRundown() {
			const filtered = this.items.filter(item => item.rundown_id);
			return filtered;
		},
	},
	created() {
		this.fetch();
		this.fetchSizes();
	},
};
</script>
